import * as React from 'react';
import * as autoBind from 'react-autobind';
import * as classNames from 'classnames';
import {Glyphs} from '@techsmith/tsc-cloud-style-guide';
import {ButtonActivationKeys} from '../../globals/Constants';

export default class CircleCheckBox extends React.Component<CircleCheckBoxProps, {}> {
   static defaultProps: Partial<CircleCheckBoxProps> = {
      ariaLabel: ''
   };

   constructor(props: CircleCheckBoxProps) {
      super(props);
      autoBind(this);
   }

   handleOnClick(e: any) {
      const {isActive, onClick} = this.props;
      if (!isActive) {
         onClick(e);
      }
   }

   onKeyDown(e: any): void {
      if (e.keyCode in ButtonActivationKeys && !e.shiftKey) {
         this.handleOnClick(e);
      }
   }

   render() {
      const {isSelected, isOwner, isActive, ariaLabel} = this.props;
      const wrapperClasses = classNames('circle-check-box-wrapper', {owner: isOwner}, {reviewer: !isOwner}, {active: isActive}, {selected: isSelected});

      return (
          <div className={wrapperClasses}>
             <div className="circle-check-box" onClick={this.handleOnClick} onKeyDown={e => this.onKeyDown(e)} tabIndex={0} role="checkbox" aria-label={ariaLabel} aria-checked={isSelected}>
                <Glyphs.Checkmark16x16 className="checkmark-glyph"/>
             </div>
          </div>
      );
   }
}

export interface CircleCheckBoxProps {
   isSelected: boolean;
   isOwner: boolean;
   isActive: boolean;
   ariaLabel?: string;
   onClick(e: any): void;
}
